export function splitRoleplayContentParts(text) {
    if (!text || typeof text !== 'string') return [];

    const parts = [];
    const dialoguePattern = /(["“].*?["”])|(^|[^\w])(['‘].*?['’])(?!\w)/g;
    let cursor = 0;
    let match;

    while ((match = dialoguePattern.exec(text)) !== null) {
        const quotedContent = match[1] || match[3];
        if (!quotedContent) continue;

        // The single-quote branch consumes the preceding non-word character so
        // it can avoid lookbehind. Keep that character in the narration part.
        const consumedPrefixLength = match[3] ? match[0].length - match[3].length : 0;
        const quoteStart = match.index + consumedPrefixLength;

        if (quoteStart > cursor) {
            parts.push(text.slice(cursor, quoteStart));
        }

        parts.push(quotedContent);
        cursor = quoteStart + quotedContent.length;
    }

    if (cursor < text.length) {
        parts.push(text.slice(cursor));
    }

    return parts.filter(Boolean);
}
